import {useCallback, useLayoutEffect} from 'react';
import {getDocument} from '../lib/utils';

export function useLockBodyScroll(needLock?: boolean) {
  const lockScroll = useCallback(() => {
    getDocument().getElementsByTagName('body')[0].style.overflow = 'hidden';
  }, []);

  const resetScroll = useCallback(() => {
    getDocument().getElementsByTagName('body')[0].style.overflow = 'auto';
  }, []);

  useLayoutEffect(() => {
    if (needLock) {
      lockScroll();
    } else {
      resetScroll();
    }
  }, [lockScroll, needLock, resetScroll]);

  return {resetScroll, lockScroll};
}
